import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from "@/modules/Core/interfaces"
import type { AxiosResponse } from 'axios'
export class JABotService extends BaseService<any> {
  constructor () {
    super({
      baseUrl: 'system/ja-bot/'
    })
  }
  async getDiagnTop3(params: Record<string,unknown>): Promise<AxiosResponse<IResponseApi<any>>> {
    return this.http.get<IResponseApi<any>>(`/get-diagnostics-top-3`,{ params })
  }
  async getDiagnostico(params: Record<string,unknown>): Promise<AxiosResponse<IResponseApi<any>>> {
    return this.http.get<IResponseApi<any>>(`/get-diagnostic`,{ params })
  }
  async getHistoriAnalisis(params: Record<string,unknown>): Promise<AxiosResponse<IResponseApi<any>>> {
    return this.http.get<IResponseApi<any>>(`/get-analisis-history`,{ params })
  }
  
  
}